import { createReducer, on } from '@ngrx/store';

import { LoadMarketLanguagesSuccess } from './market.actions';
import { MarketState } from './market.state';

const marketInitialState: MarketState = {
    marketLanguages: [],
};

export const MarketReducer = createReducer(
    marketInitialState,
    on(LoadMarketLanguagesSuccess, (state, payload): MarketState => {
        return { ...state, marketLanguages: payload.marketLanguages };
    }),
);
